import { render, staticRenderFns } from "./SharedNotFound.vue?vue&type=template&id=7f3a9fae&scoped=true"
import script from "./SharedNotFound.vue?vue&type=script&lang=js"
export * from "./SharedNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3a9fae",
  null
  
)

export default component.exports